import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function input(theme: Theme): ComponentStyle {
  return {
    componentName: 'input',
    baseStyle: {
      border: `solid 1px transparent`,
      borderRadius: '9999px',
      fontSize: theme.sizes['-1'],
      padding: `${theme.space['2xs']} ${theme.space['xs']}`,
      backgroundColor: theme.colors.hype.background70,
      fontWeight: 500,

      ['&:focus']: {
        borderColor: theme.colors.border
      }
    },
    variants: {
      textSearchFilter: {
        paddingLeft: `calc(${theme.space['l']} + ${theme.space['2xs']})`,
        paddingRight: theme.space['s']
      }
    }
  };
}
